import React from "react";

import { Button, Box, IconButton, makeStyles } from "@tiny/components";
import PageHeader from "@tiny/components/src/PageHeader";
import InfoOutline from "@tiny/icons/generated/InfoOutline";
import LongLeft from "@tiny/icons/generated/LongLeft";
import { useEditSegmentHeader } from "./EditSegmentHeader.hooks";

function EditSegmentHeader() {
  return <EditSegmentHeaderComponent {...useEditSegmentHeader()} />;
}

const useStyles = makeStyles((theme) => ({
  customNavigationLink: {
    cursor: "pointer",
    color: theme.palette.primary.main,
  },
}));

const EditSegmentHeaderComponent = React.memo(
  (props: ReturnType<typeof useEditSegmentHeader>) => {
    const {
      nameEditing,
      editName,
      saveName,
      mdUp,
      segmentName,
      cancelEditName,
      previewDisabled,
      gotoView,
      openSummary,
      editDisabled,
      editDisabledTooltip,
      goBack,
    } = props;

    const classes = useStyles();

    const previewButton = (
      <Button
        variant="contained"
        fullWidth
        disabled={previewDisabled}
        onClick={gotoView}
      >
        Save and Exit
      </Button>
    );

    const mobileActions = (
      <IconButton size="small" onClick={openSummary}>
        <InfoOutline />
      </IconButton>
    );

    const customBackNavigation = (
      <div onClick={goBack} className={classes.customNavigationLink}>
        <LongLeft />
      </div>
    );

    return (
      <>
        <Box>
          <PageHeader
            mb={mdUp ? 6 : 0}
            backUrl={undefined}
            customBackNavigation={customBackNavigation}
            onTitleCancel={cancelEditName}
            onTitleEdit={editName}
            onTitleSave={saveName}
            title={segmentName}
            titleEditLabel="Segment name"
            titleEditable
            titleEditing={nameEditing}
            hideRefresh
            titleEditDisabled={editDisabled}
            titleEditDisabledTooltip={editDisabledTooltip}
            titleMaxLength={140}
            actions={mdUp ? previewButton : mobileActions}
          />
          {!mdUp && (
            <Box px={4} pb={4}>
              {previewButton}
            </Box>
          )}
        </Box>
      </>
    );
  }
);

export default EditSegmentHeader;
